export const hvm2c = require('./habitacion-vista-mar-2-camas.jpg');
export const Logo = require('./logo.png');
export const LogopayPal = require('./logo-paypal.png');